@if (breadcrumb() && breakpoints()) {
  <ul class="list">
    @for (link of breadcrumb(); track link; let last = $last) {
      <li class="list-item {{ color() | colorClass }}">
        @if (link.title && link.url) {
          <a
            [class.link-last]="last"
            [innerHTML]="link.title | truncate: (breakpoints() === 'mobile' ? (breadcrumb().length > 2 ? 12 : 30) : 0)"
            [routerLink]="link.url"
            class="link"></a>
        }
        @if (!last) {
          <span class="link-separator">/</span>
        }
      </li>
    }
  </ul>
}
